import React from 'react';
import { TextField } from 'react-md';

export default class Explanations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      image: true,
      imageEnabled: true,
      videoEnabled: false
    };
    this.updateImageState = this.updateImageState.bind(this);
  }

  updateImageState(e) {
    //    alert(e.target.value);

    if (e.target.value === 'image') {
      this.setState({ imageEnabled: true, videoEnabled: false });
    } else {
      this.setState({ imageEnabled: false, videoEnabled: true });
    }
  }

  render() {
    return (
      <div>
        Name: <TextField value={''} />
        <br />
        Type:{' '}
        <input
          type="radio"
          id="image"
          value="image"
          onClick={this.updateImageState}
          checked={this.state.imageEnabled}
        />Image
        <input
          type="radio"
          value="video"
          id="video"
          onClick={this.updateImageState}
          checked={this.state.videoEnabled}
        />Video
      </div>
    );
  }
}
